<div *ngIf="!profileBase64" class="profile"></div>
<img *ngIf="profileBase64" [src]="profileBase64" class="profile">
